import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@dx/web/shared/environments';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
  window.console.log = () => {}
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
